import { useLinked, useModel } from "@type-r/react";
import React from "react";
import { PaymentData } from "../../api/paymentChange";
import { AssetsSection } from "../assets-section";
import { InblockedAssetsDataStep } from "../inblocked-assets-data-step";
import { InblockedAssetsTitle } from "../inblocked-assets-title";
import { PaymentExternalSystems } from "./externalSystems";
import { PaymentTile } from "./payment-tile";

export const InblockedPaymentsDataStep = ({ job, back, $refreshEvents }: { job, back?, $refreshEvents?}) => {
    const paymentChanges = useModel(PaymentData);
    const selectedPayments = useModel(PaymentData);
    const $activePayment = useLinked(null);
    const $filter = useLinked({ search: '', eventType: null });
    const $loadedAssetEvents = useLinked(false);

    const $selectAllAssets = useLinked(false);

    return <InblockedAssetsDataStep
        assetName='Payment'
        assetChanges={paymentChanges}
        selectedAssets={selectedPayments}
        $filter={$filter}
        job={job}
        back={back}
        $loadedAssetEvents={$loadedAssetEvents}
        assetsListComponent={
            (filteredAssetChanges, itemsCount, $selectAllAssets, assetEventsGeneralCount) =>
                <AssetsSection
                    height={420}
                    title={<InblockedAssetsTitle assetChanges={paymentChanges.items} externalSystems={PaymentExternalSystems} $filter={$filter} $loadedAssetEvents={$loadedAssetEvents} importJobId={job.importJobId} itemsCount={itemsCount} assetEventsGeneralCount={assetEventsGeneralCount} />}
                    assets={filteredAssetChanges}
                    assetTile={PaymentTile}
                    notExpanded={false}
                    $active={$activePayment}
                    selected={selectedPayments.items}
                    selectAllAssets={$selectAllAssets} />
        }
        externalSystems={PaymentExternalSystems}
        $refreshEvents={$refreshEvents}
        selectAllAssets={$selectAllAssets} />
};
